import { ReturnPortalSize } from './hooks/useReturnPortalSize';

export function isDesktop(size: ReturnPortalSize) {
  return size === 'l' || size === 'xl';
}

export function isTablet(size: ReturnPortalSize) {
  return size === 'm';
}
